// extracted by mini-css-extract-plugin
export var contacts = "FormContatto-module--contacts--b23ed";
export var control = "FormContatto-module--control--dd093";
export var description = "FormContatto-module--description--bbebf";
export var fieldInput = "FormContatto-module--fieldInput--d0809";
export var fields = "FormContatto-module--fields--b65dc";
export var fieldsGroup = "FormContatto-module--fieldsGroup--6e902";
export var form = "FormContatto-module--form--624e1";
export var formWrapper = "FormContatto-module--formWrapper--401d9";
export var formWrapperNoPadding = "FormContatto-module--formWrapperNoPadding--87a66";
export var mantineAlertRoot = "FormContatto-module--mantineAlertRoot--3aa88";
export var paperRoot = "FormContatto-module--paperRoot--287a2";
export var title = "FormContatto-module--title--518f8";
export var wrapper = "FormContatto-module--wrapper--e3729";